import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { Countries } from '../../../utils/countries-enum';


export class ChinaManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getCHNManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'ChinaModule'
      }, {
        'key': 'intermediary-question',
        'module': 'GlobalModule'
      }, {
        'key': 'deal-file-check-list',
        'module': 'GlobalModule'
      }, {
        'key': 'company-names',
        'module': 'ChinaModule'
      }, {
        'key': 'gaode-address-form',
        'module': 'ChinaModule'
      }, {
        'key': 'gaode-map',
        'module': 'ChinaModule'
      }, {
        'key': 'represented-party-address-gaode',
        'module': 'ChinaModule'
      }, {
        'key': 'google-address-form',
        'module': 'ChinaModule'
      }, {
        'key': 'represented-party-address-google',
        'module': 'ChinaModule'
      }, {
        'key': 'gst-fee-field',
        'module': 'ChinaModule'
      }, {
        'key': 'invoice-fee-basis',
        'module': 'ChinaModule'
      }, {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      }, {
        'key': 'customer-approval-documents',
        'module': 'GlobalModule'
      }, {
        'key': 'net-amount-calculator',
        'module': 'ChinaModule'
      }, {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      }, {
        'key': 'gst-adjust',
        'module': 'ChinaModule'
      }, {
        'key': 'net-amount-label',
        'module': 'GlobalModule'
      }, {
        'key': 'banner',
        'module': 'ChinaModule'
      }, {
        'key': 'billing-information',
        'module': 'GlobalModule'
      }, {
        'key': 'tax-fee-percent',
        'module': 'ChinaModule'
      }, {
        'key': 'recd-net-amount-calculator',
        'module': 'ChinaModule'
      }, {
        'key': 'internal-notes',
        'module': 'ChinaModule'
      }, {
        'key': 'master-billing-invoice',
        'module': 'ChinaModule'
      } 
    ];
    return this.da.generateManifest(components, Countries.China);
  }
}
